<template>
  <div class="px-4 py-3">
    <div class="flex flex-col gap-4">
      <div class="flex items-center justify-between gap-8">
        <span class="text-sm">{{ $t('W: Vis kun verificerede') }}</span>
        <button
          type="button"
          class="relative inline-flex h-5 w-9 shrink-0 cursor-pointer rounded-full transition-colors duration-200"
          :class="isVerified ? '' : 'bg-border-subtle'"
          :style="isVerified ? 'background-color: var(--color-action)' : ''"
          @click="toggleVerified">
          <span
            class="pointer-events-none mt-0.5 inline-block h-4 w-4 transform rounded-full bg-white shadow-sm transition-transform duration-200"
            :class="isVerified ? 'translate-x-4' : 'translate-x-0.5'" />
        </button>
      </div>
      <div class="flex items-center justify-between gap-8">
        <span class="text-sm">{{ $t('W: Vis kun ikke-verificerede') }}</span>
        <button
          type="button"
          class="relative inline-flex h-5 w-9 shrink-0 cursor-pointer rounded-full transition-colors duration-200"
          :class="isNotVerified ? '' : 'bg-border-subtle'"
          :style="isNotVerified ? 'background-color: var(--color-action)' : ''"
          @click="toggleNotVerified">
          <span
            class="pointer-events-none mt-0.5 inline-block h-4 w-4 transform rounded-full bg-white shadow-sm transition-transform duration-200"
            :class="isNotVerified ? 'translate-x-4' : 'translate-x-0.5'" />
        </button>
      </div>
      <div class="border-t border-border-subtle"></div>
      <div class="flex items-center justify-between gap-8">
        <span class="text-sm">{{ $t('W: Vis kun delte komponenter') }}</span>
        <button
          type="button"
          class="relative inline-flex h-5 w-9 shrink-0 cursor-pointer rounded-full transition-colors duration-200"
          :class="isPackage ? '' : 'bg-border-subtle'"
          :style="isPackage ? 'background-color: var(--color-action)' : ''"
          @click="togglePackage">
          <span
            class="pointer-events-none mt-0.5 inline-block h-4 w-4 transform rounded-full bg-white shadow-sm transition-transform duration-200"
            :class="isPackage ? 'translate-x-4' : 'translate-x-0.5'" />
        </button>
      </div>
      <div class="flex items-center justify-between gap-8">
        <span class="text-sm">{{ $t('W: Vis kun lokale komponenter') }}</span>
        <button
          type="button"
          class="relative inline-flex h-5 w-9 shrink-0 cursor-pointer rounded-full transition-colors duration-200"
          :class="isNotPackage ? '' : 'bg-border-subtle'"
          :style="isNotPackage ? 'background-color: var(--color-action)' : ''"
          @click="toggleNotPackage">
          <span
            class="pointer-events-none mt-0.5 inline-block h-4 w-4 transform rounded-full bg-white shadow-sm transition-transform duration-200"
            :class="isNotPackage ? 'translate-x-4' : 'translate-x-0.5'" />
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { useDesignSystemStore } from '@/stores/designSystemStore'
import { mapState } from 'pinia'

export default {
  name: 'DesignSystemVerifiedFilterMenu',

  emits: ['close'],

  computed: {
    ...mapState(useDesignSystemStore, ['verifiedFilter', 'packageFilter']),

    isVerified(): boolean {
      return this.verifiedFilter === 'verified'
    },

    isNotVerified(): boolean {
      return this.verifiedFilter === 'not-verified'
    },

    isPackage(): boolean {
      return this.packageFilter === 'package'
    },

    isNotPackage(): boolean {
      return this.packageFilter === 'not-package'
    },
  },

  methods: {
    toggleVerified() {
      const store = useDesignSystemStore()
      store.verifiedFilter = this.isVerified ? 'all' : 'verified'
    },

    toggleNotVerified() {
      const store = useDesignSystemStore()
      store.verifiedFilter = this.isNotVerified ? 'all' : 'not-verified'
    },

    togglePackage() {
      const store = useDesignSystemStore()
      store.packageFilter = this.isPackage ? 'all' : 'package'
    },

    toggleNotPackage() {
      const store = useDesignSystemStore()
      store.packageFilter = this.isNotPackage ? 'all' : 'not-package'
    },
  },
}
</script>
